import React, { useContext, useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { AuthContext } from '../context/AuthContext'
import Cookies from 'js-cookie'
import { getColleges, getAvailableCRNs } from '../service/sessionService'
import '../css/login.scss'

const SignUp = () => {
  const [err, setErr] = useState(false)
  const navigate = useNavigate()
  const { handleSignUp } = useContext(AuthContext)

  const [colleges, setColleges] = useState([])
  const [crns, setCrns] = useState([])
  const [selectedCollege, setSelectedCollege] = useState('')
  const [selectedCRN, setSelectedCRN] = useState('')

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedColleges = await getColleges()
        const fetchedCRNs = await getAvailableCRNs()
        setColleges(fetchedColleges)
        setCrns(fetchedCRNs)
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    }
    fetchData()
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    const firstname = e.target[0].value
    const middlename = e.target[1].value
    const lastname = e.target[2].value
    const email = e.target[3].value
    const password = e.target[4].value
    const confirmPassword = e.target[5].value

    if (password !== confirmPassword) {
      setErr("Passwords don't match")
      return
    }

    try {
      const userInfo = {
        firstname,
        middlename,
        lastname,
        email,
        password,
        college: selectedCollege,
        crn: selectedCRN,
      }
      await handleSignUp(userInfo)
      Cookies.set('VisPI_userId', userInfo.email) // Adjust as needed
      navigate('/')
    } catch (err) {
      console.error(err)
      if (err.response?.status === 400) {
        setErr('Email already exists')
      } else {
        setErr('Something went wrong')
      }
    }
  }

  return (
    <div className="formContainer">
      <div className="formWrapper">
        <span className="logo">VizPI</span>
        {/* <span className="title">Sign Up</span> */}
        <form onSubmit={handleSubmit} className="signupForm">
          <input type="text" placeholder="First Name" required />
          <input type="text" placeholder="Middle Name" />
          <input type="text" placeholder="Last Name" required />
          <input type="email" placeholder="Email" required />
          <input type="password" placeholder="Password" required />
          <input type="password" placeholder="Confirm Password" required />

          {/* College Selection */}
          <select 
            value={selectedCollege} 
            onChange={(e) => setSelectedCollege(e.target.value)} 
            required 
            className="styledSelect"
          >
            <option value="">Select College</option>
            {colleges.map((college, idx) => (
              <option key={idx} value={college}>{college}</option>
            ))}
          </select>

          {/* CRN Selection */}
          <select 
            value={selectedCRN} 
            onChange={(e) => setSelectedCRN(e.target.value)} 
            required 
            className="styledSelect"
          >
            <option value="">Select CRN</option>
            {crns.map((crn, idx) => (
              <option key={idx} value={crn}>{crn}</option>
            ))}
          </select>

          <div className="signupButton">
            <button type="submit">Sign up</button>
          </div>
          <p>
            Already have an account? <Link to="/login">Login</Link>
          </p>
          {err && <span className="error">{err}</span>}
        </form>
      </div>
    </div>
  )
}

export default SignUp
